import Bracket from './Bracket.container';

export default Bracket;
